import { render, staticRenderFns } from "./city_letter.vue?vue&type=template&id=37809824"
import script from "./city_letter.vue?vue&type=script&lang=js"
export * from "./city_letter.vue?vue&type=script&lang=js"
import style0 from "./city_letter.vue?vue&type=style&index=0&id=37809824&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports